var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{ref:"buttonRef",staticClass:"aha-antd-button",class:[
    {
      'btn-underline': _vm.underline,
      'disabled': _vm.disabled,
      'is-loading-inline': _vm.isLoadingInline,
      'has-icon': _vm.iconName.length && !_vm.submitting,
      'has-icon-only': _vm.iconName.length && !(_vm.$slots.default && _vm.$slots.default.length),
      'active': _vm.active
    },
    `ant-btn-${_vm.variant}`,
    `ant-btn-${_vm.size}`,
    'ant-btn-custom'

  ],attrs:{"type":_vm.variant,"loading":_vm.submitting,"disabled":_vm.disabled,"ghost":_vm.ghost,"icon":_vm.antIcon,"block":_vm.block},on:{"click":_vm.handleClick}},[(_vm.iconName.length && !_vm.submitting)?_c('aha-icon',{class:_vm.iconClasses,attrs:{"name":_vm.iconName,"height":_vm.iconSize,"width":_vm.iconSize,"viewBox":_vm.iconViewBox,"maintainColor":_vm.iconMaintainColor}}):_vm._e(),(_vm.$slots.default && _vm.$slots.default.length)?_c('div',{staticClass:"--content-container",class:{ 'invisible': _vm.isLoadingInline && _vm.submitting }},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }